import { OptimisticUpdate } from "../../block/optimisticBlockStore";
import { BlockType } from "../../../types/block/type";
import { processBlocksNotInServer, processServerBlocks } from "./blockMergeProcessors";
import { ProcessingContext } from "./type";
import { OptimisticMaps } from "./type";

const createOptimisticMaps = (patches: OptimisticUpdate[]): OptimisticMaps => {
  // NOTE 한 번의 순회로 각각의 map 생성을 위해 reduce 활용
  return patches.reduce(
    (maps, patch) => {
      if (patch.isDeletedBlock) {
        maps.deletedPatchMap.set(String(patch.id), patch.data);
      } else if (patch.isNewBlock) {
        maps.newBlockPatchMap.set(patch.data?.clientId || "", patch);
      } else {
        maps.updatePatchMap.set(String(patch.id), patch.data);
      }
      return maps;
    },
    {
      deletedPatchMap: new Map(),
      updatePatchMap: new Map(),
      newBlockPatchMap: new Map(),
    } as OptimisticMaps
  );
};

const createProcessingContext = (
  serverData: BlockType[],
  patches: OptimisticUpdate[]
): ProcessingContext => {
  // NOTE 한 번의 순회로 각각의 map 생성을 위해 reduce 활용
  const { serverIds, serverClientIds } = serverData.reduce(
    (acc, item) => {
      acc.serverIds.add(String(item.id));
      acc.serverClientIds.add(item.clientId ?? null);
      return acc;
    },
    {
      serverIds: new Set<string>(),
      serverClientIds: new Set<string | null>(),
    }
  );
  return {
    serverIds,
    serverClientIds,
    optimisticMaps: createOptimisticMaps(patches),
  };
};

export const mergeClientServerBlocks = (
  serverData: BlockType[],
  patches: OptimisticUpdate[]
): BlockType[] => {
  const context = createProcessingContext(serverData, patches);

  const processedServerData = serverData
    .map((serverItem) => processServerBlocks(serverItem, context, serverData))
    .filter(Boolean) as BlockType[];

  const newOptimisticBlocks = processBlocksNotInServer(patches, context);

  return [...processedServerData, ...newOptimisticBlocks];
};
